import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFashion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFashion"><Path d="M20.925 11.564L22.5 7.10606L15.15 3.5C14.1237 6.86337 9.87628 6.86337 8.85 3.5L1.5 7.10606L3.075 11.564L5.5 10.4031V20.5H18.5V10.4031L20.925 11.564Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFashion;
